<astrea-internal-banner
    title="{{ 'faq' | translate }}"
></astrea-internal-banner>

<div class="astrea-faq content-height p-sm-4 p-2">
    <div class="container d-flex j-c-center a-i-center flex-column">

        <div *ngIf="books && books.length > 0" class="faqs-wrapper animated astreaFade">
            <div class="astrea-subtitle my-3">
                <h2>{{ 'faq_page.books' | translate }}</h2>
            </div>
            <astrea-faq
                *ngFor="let f of books"
                [faq]="f"
            ></astrea-faq>
        </div>

        <div *ngIf="purchases && purchases.length > 0" class="faqs-wrapper animated astreaFade">
            <div class="astrea-subtitle my-3">
                <h2>{{ 'faq_page.purchases' | translate }}</h2>
            </div>
            <astrea-faq
                *ngFor="let f of purchases"
                [faq]="f"
            ></astrea-faq>
        </div>

        <div *ngIf="payments && payments.length > 0" class="faqs-wrapper animated astreaFade">
            <div class="astrea-subtitle my-3">
                <h2>{{ 'faq_page.payments' | translate }}</h2>
            </div>
            <astrea-faq
                *ngFor="let f of payments"
                [faq]="f"
            ></astrea-faq>
        </div>

        <div *ngIf="av && av.length > 0" class="faqs-wrapper animated astreaFade">
            <div class="astrea-subtitle my-3">
                <h2>{{ 'faq_page.av' | translate }}</h2>
            </div>
            <astrea-faq
                *ngFor="let f of av"
                [faq]="f"
            ></astrea-faq>
        </div>

    </div>
</div>
